export const LOADING_DISTRIBUTION_VEHICLE = "LOADING_DISTRIBUTION_VEHICLE";
export const GET_DISTRIBUTION_VEHICLE_LIST = "GET_DISTRIBUTION_VEHICLE_LIST";
export const GET_DISTRIBUTION_VEHICLEBYID = "GET_DISTRIBUTION_VEHICLEBYID";
export const REMOVE_DISTRIBUTION_VEHICLE = "REMOVE_DISTRIBUTION_VEHICLE";
export const ADD_DISTRIBUTION_VEHICLE = "ADD_DISTRIBUTION_VEHICLE";
export const UPDATE_DISTRIBUTION_VEHICLE = "UPDATE_DISTRIBUTION_VEHICLE";